if (!customElements.get('selling-plan-picker')) {
  customElements.define(
    'selling-plan-picker',
    class SellingPlanPicker extends HTMLElement {
      connectedCallback() {
        this.frequencyWrap = this.querySelector('.js-frequency-wrap');
        this.oneTimePriceEl = this.querySelector('.js-one-time-price');
        this.subscribePriceEl = this.querySelector('.js-subscribe-price');
        this.subscribeCompareEl = this.querySelector('.js-subscribe-compare');
        this.form = this.closest('form');
        this.priceRoot = document.getElementById(`price-${this.dataset.section}`);

        const dataEl = this.querySelector('.js-selling-plan-data');
        this.planData = {};
        try {
          this.planData = JSON.parse(dataEl.textContent);
        } catch (error) {
          console.error(error);
        }

        this.addEventListener('change', () => this.sync());

        const variantInput = this.form?.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.addEventListener('change', () => this.syncPrices());
        }

        if (this.priceRoot) {
          new MutationObserver(() => this.syncPrices()).observe(this.priceRoot, {
            childList: true,
            subtree: true,
          });
        }

        this.sync();
      }

      get frequencySelect() {
        return this.querySelector('.js-frequency-select, .js-frequency-select');
      }

      get variantId() {
        return this.form?.querySelector('input[name="id"]')?.value;
      }

      get isSubscribe() {
        return Boolean(this.querySelector('[data-purchase-type="subscribe"]')?.checked);
      }

      getSelectedPlanId() {
        if (!this.isSubscribe) return '';
        return this.frequencySelect?.value || '';
      }

      sync() {
        const subscribe = this.isSubscribe;
        this.frequencyWrap?.classList.toggle('selling-plan-picker__frequency--hidden', !subscribe);

        const select = this.frequencySelect;
        if (select) {
          select.disabled = !subscribe;
          if (subscribe) {
            select.setAttribute('name', 'selling_plan');
          } else {
            select.removeAttribute('name');
          }
        }

        this.setPlanId(this.getSelectedPlanId());
        this.syncPrices();
      }

      setPlanId(planId) {
        const value = planId || '';
        const inputs = new Set(this.querySelectorAll('input.js-selling-plan-id'));
        document.querySelector('sticky-cart-modal')?.querySelectorAll('.js-selling-plan-id').forEach((input) => {
          inputs.add(input);
        });

        inputs.forEach((input) => {
          input.value = value;
          input.disabled = !value;
        });

        const label =
          value && this.frequencySelect?.selectedOptions?.[0]
            ? this.frequencySelect.selectedOptions[0].textContent.trim()
            : '';
        document.querySelectorAll('.js-sticky-selling-plan').forEach((el) => {
          el.hidden = !label;
          el.textContent = label;
        });
      }

      syncPrices() {
        const variant = this.planData[this.variantId];
        if (!variant) return;

        if (this.oneTimePriceEl) this.oneTimePriceEl.textContent = variant.price_money;

        const allocation = variant.allocations?.[this.frequencySelect?.value];
        if (this.subscribePriceEl && allocation) {
          this.subscribePriceEl.textContent = allocation.price_money;
        }

        if (this.subscribeCompareEl) {
          const showCompare = Boolean(
            this.isSubscribe && allocation && allocation.price_money !== variant.price_money
          );
          this.subscribeCompareEl.textContent = variant.price_money;
          this.subscribeCompareEl.hidden = !showCompare;
        }

        this.updateMainPrice(variant, allocation);
      }

      updateMainPrice(variant, allocation) {
        if (!this.priceRoot) return;
        const main = this.priceRoot.querySelector('.price__main__value');
        if (!main) return;

        const next = this.isSubscribe && allocation ? allocation.price_money : variant.price_money;
        if (main.textContent.trim() !== next) {
          main.textContent = next;
        }
      }
    }
  );
}
